<template>
  <div class="announs" v-if="announs.length">
    <template v-for="(item, i) in announs">
      <!-- <transition name="announs">
        <div
          class="item"
          :style="{background: item.background, transform: `translateY(${100 * (i+1)}%)`}"
          :key="item.id"
          v-if="item.status"
        >
          <span>
            {{ item.description }}
          </span>
          <span @click="close(item)"></span>
        </div>
      </transition> -->
      {{ item.description }}
    </template>
  </div>
</template>

<script>
import API from '@/api';

export default {
  data () {
    return {
      announs: [],
      block: []
    }
  },
  methods: {
    sync () {
      API.announs.getOpen().then(res => {
        this.announs = res.data.data;
      });

      // if (localStorage.blockAnnouns) {
      //   this.block = JSON.parse(localStorage.blockAnnouns);
      // }
    },
    close (item) {
      // item.status = false;
      // this.block.push(item.id);
      //
      // localStorage.blockAnnouns = JSON.stringify(this.block);
    }
  },
  created () {
    this.sync();
  },
  computed: {
    showAnnouns: function () {
      var res = [];

      var i = 0;
      for (var item of this.announs) {
        if (i < 3 && !this.block.includes(item.id)) {
          res.push(item);
          i++;
        }
      }

      return res;
    }
  }
}
</script>

<style lang="scss" scoped>
.announs-enter-active, .announs-leave-active {
  transition: all 1s ease;
}
.announs-enter, .announs-leave-to {
  // transform: translateY(0);
  opacity: 0;
}

.announs {
  // position: fixed;
  // top: -38px;
  width: 100%;
  // height: 38px;
  flex-basis: 100%;
  z-index: 100;
  padding: 0 12px;
  background-color: #F2B14E;
  box-sizing: border-box;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  // margin-bottom: 8px;
  .item {
    display: inline-block;
    // width: 100%;
    // height: 100%;
    // position: absolute;
    // bottom: 0;
    // left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // padding: 0 18px;
    // transform: translateY(0);
    // color: white;
    background-color: #F2B14E;
    font-size: 14px;
    // transition: all 1s ease;

    span:last-child {
      // position: relative;

      // &::before, &::after {
      //   content: '';
      //   position: absolute;
      //   height: 3px;
      //   width: 20px;
      //   background: #000;
      //   cursor: pointer;
      //   left: -20px;
      // }
      // &::before {
      //   transform: rotate(-45deg);
      // }
      // &::after {
      //   transform: rotate(45deg);
      // }
    }
  }
}
</style>
